import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    gridContainer: { margin: theme.spacing(6, 0) },
    gridChild: {
      display: "flex",
      flexDirection: "column",
    },
    avatar: {
      width: "49px",
      height: "48px",
      backgroundColor: theme.gray100,
      border: "1px solid rgba(229, 226, 241, 0.1)",
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "19px",
      color: theme.gray800,
    },
    detailsPaper: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
    },
    mainDataContainer: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(6, 8),
      gap: theme.spacing(8),
      boxShadow: `0px 1px 0px ${theme.gray100}`,
    },
    rewardDataContainer: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8),
      gap: theme.spacing(8),
    },
    smallText: {
      color: theme.gray500,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    largeText: {
      color: theme.gray800,
      fontSize: "16px",
      lineHeight: "24px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    singleFilter: {
      margin: theme.spacing(4, 4, 0, 0),
    },
    btn: {
      border: `1px solid ${theme.gray200}`,
      boxShadow:
        "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
    },
    htmlContainer: {
      "& *": {
        wordBreak: "break-all",
      },

      "& ul,ol": {
        margin: 0,
        paddingLeft: theme.spacing(12),
      },

      "& p": {
        margin: theme.spacing(4, 0),
      },
    },
    overflowText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  }),
);
